import * as React from 'react';
import { PaymentInstructionLayout } from '../../../component/PaymentInstructionLayout.js';

const CashOnDelivery = ()=>{
    return /*#__PURE__*/ React.createElement(PaymentInstructionLayout, {
        info: "checkout.payment.method.cash_on_delivery.info"
    });
};

export { CashOnDelivery };
//# sourceMappingURL=CashOnDelivery.js.map
